export default "__VITE_ASSET__QyaTtcuM__"